<template>
    <div class="">
        <false-dashboard>

            <div class="mt-5 ml-lg-5 pl-lg-4">

                <div class="" v-if="loading"><p>loading...</p></div>

                <div class="d-flex align-items-center" v-if="pool != null">
                    <div class="col-lg-8 col-md-12 p-0">
                        <div class="mb-4" v-if="poolPaid && poolAccepted">
                            <div class="alert alert-info alert-dismissable">
                                <a class="panel-close close" data-dismiss="alert">×</a> 
                                You have already contributed to this pool. 
                                <a href="/dashboard" class="btn btn-link btn-sm small">Go to dashboard</a>
                            </div>
                        </div>
                        <div class="mb-4" v-if="poolAccepted && !poolPaid">
                            <div class="alert alert-info alert-dismissable">
                                <a class="panel-close close" data-dismiss="alert">×</a> 
                                You have already accepted this pool. 
                                
                                <router-link class="btn btn-link btn-sm" :to="{ name: 'make-contribution', params: { 
                                            pool_id: this.pool_id,
                                            invite_id: this.invite_id,
                                        } }"> 
                                    Proceed to contribute
                                </router-link>
                            </div>
                        </div>

                        <!-- invitee card -->
                        <div v-if="invitee != null">
                            <div class="mb-3 card border-0  ">
                                <div class="invitee-card card-body d-flex flex-wrap align-items-center mb-2">
                                    <div class="avatar-image mr-3">
                                        <img src="@/assets/avatar-purple.png" 
                                            class="img-fluid rounded-circle d-block" alt="avatar" 
                                            style="height:60px;"
                                        >
                                    </div>

                                    <div>
                                        <div class="invitee-detail">
                                            <h6 class="font-weight-bold m-0">{{ invitee.name}}</h6>
                                            <p class="m-0">{{ invitee.email }}</p>
                                            <p class="m-0 small">{{ invitee.phone }}</p>
                                        </div>
                                    </div>
                                    <div class="ml-auto">
                                        <div class="" v-if="userIsAuthenticated">
                                            <span class="badge badge-success">Logged in</span>
                                        </div>
                                        <div class="" v-else>
                                            <button class="btn btn-link btn-sm">Not you?</button>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div class="card shadow-sm border-0" v-if="canAccept">
                            <div class="card-body p-0 m-0"  v-if="userExists && !loading">
                                <!-- <img src="@/assets/placeholder.png" alt="" style="width: 100%; height: 200px;"> -->
                                <div class="body-card px-md-4 px-3 py-4">
                                    <div class="pool-details mb-3">
                                        <small class="text-muted ft-16 mb-3" style="">Title</small>
                                        <h5 class="font-weight-bold ">{{ pool.name }} </h5>
                                        <!-- <small class="text-muted">Organized by <span v-if="pool_convener != null">{{ poolConvenerName }}</span> </small> -->
                                    </div> <hr>

                                    <div class="about">
                                        <h6 class="small text-muted">About</h6>
                                        <p class="">{{ pool.description}}</p>

                                        <div class="d-flex">
                                            <span></span>
                                            <small class="ml-auto text-muted">
                                                {{ pool.created_at | dayDateFormat }}
                                            </small>
                                        </div>
                                    </div> <hr>

                                    <div class="mb-3">


                                        <div class="row mb-3 py-2">
                                            <div class="col-md-6 mb-3 mb-5">
                                                <div class="d-flex">
                                                    <span class="fa fa-user-plus fa-sm mr-3"></span>
                                                    <div class="d-flex flex-column">
                                                        <p class="h6 mb-1">
                                                            {{ pool.member_count - 1 }} other contributors
                                                        </p>
                                                        <small class="text-muted">{{ pool.amount_payable | moneyformat }} each</small>

                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-6 mb-5">
                                                <div class="d-flex">
                                                    <span class="fa fa-clock fa-sm mr-3"></span>
                                                    <div class="d-flex flex-column">
                                                        <p class="h6 mb-1">
                                                            {{ pool.contribution_deadline | diffFromNow }} to go
                                                        </p>
                                                        <small class="text-muted">Time until the contribution closes.</small>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-6 mb-4">
                                                <div class="d-flex">
                                                    <span class="fa fa-hourglass fa-sm mr-4"></span>
                                                    <div class="d-flex flex-column">
                                                        <p class="h6 mb-1 mt-0">
                                                           5 day holding period
                                                        </p>
                                                        <small class="text-muted">
                                                            The contributions would be held in escrow for a minimum of 5 days before payout can be initiated.
                                                        </small>
                                                    </div>
                                                </div>

                                            </div>
                                            <div class="col-md-6">
                                                <div v-if="pool.payout_rule == 'majority-vote'">
                                                    <div class="d-flex">
                                                        <span class="fa fa-poll fa-sm mr-4"></span>
                                                        <div class="d-flex flex-column">
                                                            <p class="h6 mb-1 mt-0">
                                                                Contributors vote to decide payout recipients
                                                            </p>
                                                            <small class="text-muted">
                                                                A majority vote would be required to decide who receives the payout from the moneypool.
                                                            </small>
                                                        </div>
                                                    </div> 
                                                </div>
                                                <div v-if="pool.payout_rule == 'organizer-autonomy'">
                                                    <div class="d-flex">
                                                        <span class="fa fa-poll fa-sm mr-4"></span>
                                                        <div class="d-flex flex-column">
                                                            <p class="h6 mb-1 mt-0">
                                                                The organizer decides on the payout recipient(s)
                                                            </p>
                                                            <small class="text-muted">
                                                                The organizer decides on who would receive the contributed amount at the end of the pool.
                                                            </small>

                                                        </div>
                                                    </div> 
                                                </div>
                                            </div>
                                        </div>
                                        <hr>
                                        <div class="mb-3">
                                            <p class="mb-5 h6">You are to contribute the sum of: 
                                                <span class="h5 font-weight-bold text-success">&#8358;{{ pool.amount_payable | moneyformat}}</span>
                                            </p> 

                                            <div>
                                                <form @submit.prevent="acceptInvite()">
                                                    <div class="d-md-block d-none mt-5">
                                                        <div class=" d-flex ">
                                                            <button class="btn btn-custom mr-2" type="submit">Accept Invite</button>
                                                            <button class="btn btn-outline-dark btn-lg" @click.prevent="rejectInvite()">Reject Invite</button>

                                                        </div>
                                                    </div>
                                                    <div class="mt-3">
                                                        <div class="d-md-none d-sm-block">
                                                            <div class="">
                                                                <button class="btn btn-custom  btn-block mr-2" type="submit">Accept Invite</button>
                                                                <button class="btn btn-outline-dark btn-block btn-lg mt-2" @click.prevent="rejectInvite()">Reject Invite</button>
                                                            </div>

                                                        </div>
                                                    </div>

                                                </form>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-10 offset-md-1" v-if="!userExists && !loading">

                                <div class="card-body">
                                    <form @submit.prevent="acceptInvite()">
                                        <div class="form-group mb-2">
                                            <label for="" class="mb-1"><small>Password</small></label>
                                            <input class="form-control" v-model.lazy="$v.form.password.$model" type="password" required autofocus>
                                            <small class="text-danger" v-if="$v.form.password.$dirty && !$v.form.password.minLength">Password must have a minimum of 6 characters.</small>
                                            <small class="text-danger" v-if="$v.form.password.$dirty && !$v.form.password.required">Password is required</small>
                                        </div>
                                        <div class="form-group">
                                            <label for="" class="mb-1 "><small>Confirm Password</small></label>
                                            <input class="form-control" v-model.lazy="$v.form.password_confirmation.$model" type="password" required>
                                            <small class="text-danger" v-if=" $v.form.password_confirmation.$dirty && !$v.form.password_confirmation.sameAsPassword">Password doesn't match.</small>

                                        </div>

                                        <div class="form-group">
                                            <div class="mt-4">
                                                <button class="btn btn-custom btn-block btn-lg" type="submit">Accept Invite</button>
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <div class="text-center">
                                                <button class="btn btn-link" type="button" @click.prevent="rejectInvite()">Reject Invite</button>
                                            </div>
                                        </div>
                                    </form>

                                </div>
                            </div>
                        </div>

                        <!-- <div class="card shadow-sm border-0">
                            <div class="card-body">
                                <div v-if="! userIsAuthenticated && !userExists && !loading">
                                    <form @submit.prevent="acceptInvite()">
                                        <div class="form-group mb-2">
                                            <label for="" class="mb-1"><small>Password</small></label>
                                            <input class="form-control" v-model="form.password" type="password" required autofocus>
                                        </div>
                                        <div class="form-group">
                                            <label for="" class="mb-1 "><small>Password Confirmation</small></label>
                                            <input class="form-control" v-model="form.password_confirmation" type="password" required>
                                        </div>

                                        <div class="form-group">
                                            <div class="mt-5">
                                                <button class="btn btn-custom btn-block btn-lg" type="submit">Accept Invite</button>
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <div class="text-center">
                                                <button class="btn btn-link" type="button" @click.prevent="rejectInvite()">Reject Invite</button>
                                            </div>
                                        </div>
                                    </form>

                                </div>
                            </div>
                        </div> -->
                    </div>
                </div>
                
            </div>


        </false-dashboard>
        
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import FalseDashboard from '@/components/FalseDashboard'
import { required, sameAs, minLength } from 'vuelidate/lib/validators'

export default {
    name: 'AcceptInvite',
    components: {
        FalseDashboard
    },
    data() {
        return {
            form: {
                password: '',
                password_confirmation: '',
                invite_id: this.$route.params.invite_code
            },
            invite_id: this.$route.params.invite_code,
            pool_id: this.$route.params.pool_id,
            userIsAuthenticated: false,
            userExists: false,
            loading: false,
            pool_accepted: false,
            pool_paid: false,
            user_message: ''
        }
    },
    validations: {
        form: {
            password: {
                required,
                minLength: minLength(6)
            },
            password_confirmation: {
                sameAsPassword: sameAs('password')
            }

        }
    },
    created() {
        this.$store.dispatch('listInvitedContributors', this.pool_id);
        this.$store.dispatch('getInviteeDetails', this.invite_id);
        this.$store.dispatch('getPool', this.pool_id);
    },
    computed: {
        ...mapGetters([
            'invitee',
            'isAuth',
            'pool',
            'pool_invitees'
        ]),

        poolPaid() {
            if (this.pool_invitees != null) {

                const member = this.pool_invitees.members.filter(invitee => invitee.invite_id == this.invite_id);

                if ( member.length == 1) {
                    const [{ paid_status, is_invite_accepted }] = member;
    
                    return paid_status ? true : false 
                }
            }
        },

        poolAccepted() {
            if (this.pool_invitees != null) {

                const member = this.pool_invitees.members.filter(invitee => invitee.invite_id == this.invite_id);

                if ( member.length == 1) {
                    const [{ paid_status, is_invite_accepted }] = member;

                    return is_invite_accepted ? true : false 
                }
            }
        },

        canAccept() {
            if (this.pool_invitees != null) {

                const member = this.pool_invitees.members.filter(invitee => invitee.invite_id == this.invite_id);

                if ( member.length == 1) {
                    const [{ paid_status, is_invite_accepted }] = member;
    
                    return is_invite_accepted == false ? true : false;
                }
            }
        }

    },
    watch: {
        invitee() {
            this.loginUserWithEmail()
        }
    },
    methods: {

        checkIfUserHasContributed() {
            if (this.pool_invitees != null) {

                const member = this.pool_invitees.members.filter(invitee => invitee.invite_id == this.invite_id);

                if ( member.length == 1) {
                    const [{ paid_status, is_invite_accepted }] = member;

                    console.log(paid_status, is_invite_accepted)
    
                    if (is_invite_accepted && paid_status) {
                        this.pool_paid = true;
                        this.pool_accepted =  true;

                        this.user_message = 'You have already accepted and contributed to this pool'
                    }
    
                    if (is_invite_accepted && paid_status == false) {

                        this.pool_accepted = true;
                        this.pool_paid = false;
                    }
                }
            }

        },

        async loginUserWithEmail() {

            await this.checkIfUserHasContributed();

            try {
                this.loading = true

                const user = await axios.post('/auth/loginViaEmail', { email: this.invitee.email }, {
                    validateStatus: function (status) {
                        return status <= 400; // Reject only if the status code is equal to 400
                    }
                });

                if (user.status == 400) {
                    this.loading = false;
                }
                
                if (user.status == 200) {

                    this.loading = false // loading state
                    this.userExists = true;

                    const { access_token, expires_in, token_type } = user.data;

                    localStorage.setItem('access_token', access_token);
                    localStorage.setItem('expires_in', expires_in);
                    localStorage.setItem('token_type', token_type);

                    const headers = { Authorization: `Bearer ${access_token}`};

                    const logged_in_user = await axios.post('/auth/me', {}, { headers });
                    
                    if (logged_in_user.status == 200) {
                        localStorage.setItem('user', JSON.stringify(logged_in_user.data));
                        
                        this.userIsAuthenticated = true;
                        // set axios authorization header
                        axios.defaults.headers.Authorization = `Bearer ${access_token}`;                
                    }
                }

            } catch (error) {
                this.loading = false;
            }
        },
        
        async acceptInvite() {

            try {
                const accept = await axios.post('/pool/invite/accept', this.form);

                if (accept.status == 200) {

                    const { message } = accept.data;

                    if (message instanceof Object) { // if message is an object
                        // store token, user 
                        const { token, user } = message;
    
                        localStorage.setItem('access_token', token);
                        localStorage.setItem('user', JSON.stringify(user));
                        localStorage.setItem('token_type', 'Bearer');
                        // user is logged in
                        this.$router.replace({ name: 'make-contribution', params: { 
                                pool_id: this.pool_id,
                                invite_id: this.invite_id,
                            } 
                        });
                        // set axios authorization header
                        axios.defaults.headers.Authorization = `Bearer ${token}`;                

                    } else {
                        // invite has already been accepted
                        this.$notify({
                            group: 'foo',
                            type: 'error',
                            title: 'Error',
                            text: `${message}`
                        });                   
                    }
                }

            } catch (error) {
                // console.log(error);
            }
        },

        async rejectInvite() {
            try {
                const reject = await axios.post('/pool/invite/decline',{ invite_id: this.invite_id });

                if (reject.status == 200 && reject.data.status == 'ok') {

                    this.$notify({
                        group: 'foo',
                        type: 'success',
                        title: 'Success',
                        text: reject.data.message
                    });

                    this.$router.replace('/thank-you');
                }

                console.log(reject);
            } catch (error) {
                // console.log(error.response);
            }
        },
    }
}
</script>

<style>

</style>